<template>
<!-- 账户信息-->
  <div class="content">
    <!-- 上半部分-->
    <div class="con_header">
      <span class="header_title">账户中心<span>|</span></span>
      <div class="header_con">
        <div class="header_item">
          <span class="item_title">用户名：</span>
          <el-input class="item_con" v-model="userInfo.username" placeholder="" size="small"></el-input>
          <div class="modify_btn item_btn" :class="{modify_button: modifyBtnDisabled}" @click="modifyUsername">修改</div>
        </div>
        <div class="header_item">
          <span class="item_title">注册时间：</span>
          <span class="registration_time item_con">{{userInfo.createTime.substring(0, userInfo.createTime.length - 5)}}</span>
        </div>
        <div class="header_item">
          <span class="item_title">企业认证：</span>
          <div class="item_con" :class="userInfo.companyStatus | classFilter">{{companyStatusValue}}</div>
        </div>
        <div class="header_item">
          <span class="item_title">个人认证：</span>
          <div class="item_con" :class="userInfo.personStatus | classFilter">{{personStatusValue}}</div>
        </div>
      </div>
    </div>
    <!-- 下半部分-->
    <el-row class="half_bottom">
      <!-- left -->
      <el-col :span="12">
        <div class="info_box">
          <span class="header_title">企业信息<span>|</span></span>
          <div class="items">
            <div class="item">
              <div class="item_name">企业名称：</div>
              <div class="item_con">{{userInfo.companyName}}</div>
            </div>
            <div class="item">
              <div class="item_name">统一社会信用代码：</div>
              <div class="item_con">{{userInfo.companyCode}}</div>
            </div>
            <div class="item">
              <div class="item_name">法定代表人：</div>
              <div class="item_con">{{userInfo.legalName}}</div>
            </div>
          </div>
          <div class="button" @click="recertification">重新认证</div>
        </div>
      </el-col>
      <!-- right -->
      <el-col :span="12" style="padding-left:2%">
        <div class="info_box">
          <span class="header_title">个人信息<span>|</span></span>
          <div class="items">
            <div class="item">
              <div class="item_name">姓名：</div>
              <div class="item_con">{{userInfo.memberName}}</div>
            </div>
            <div class="item">
              <div class="item_name">身份证号：</div>
              <div class="item_con">{{idCardValue}}</div>
              <div class="item_btn" @click="displayIdNumber">
                <img :src="imgUrl" alt="">
              </div>
            </div>
            <div class="item">
              <div class="item_name"></div>
              <div class="item_con"></div>
            </div>
          </div>
          <div class="button" @click="recertification">重新认证</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryMemberInfoByUserId, editMemberUsername } from '@/api/console/accountCenter.js'
import token from '@/utils/token.js'
export default {
  data() {
    return {
      userInfo: {
        id: '',
        username: '',
        createTime: '',//注册时间
        companyStatus: '',//企业认证
        personStatus: '',//个人认证
        companyName: '',
        companyCode: '',
        legalName: '',
        memberIDCard: '',//身份证号
      },
      usernameValue: '',//用户名
      companyStatusValue: '',//企业认证
      personStatusValue: '',//个人认证
      idCardValue: '',//身份证号
      modifyBtnDisabled: true,//是否禁用修改用户名按钮
      imgUrl: require('../../../../assets/console/eyes_close.png'),
      flag: 0,
    }
  },
  watch: {
    //监听用户名
    'userInfo.username': function(newValue, oldValue) {
      if(newValue == '' || newValue == this.usernameValue) {
        this.modifyBtnDisabled = true;
      } else {
        this.modifyBtnDisabled = false;
      }
    }
  },
  filters: {
    //认证状态判断
    classFilter(val) {
      if(val == '0') {
        return 'unauthenticated_btn'
      } else if(val == '1') {
        return 'review_btn'
      } else if(val == '2') {
        return 'success_btn'
      }
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      let userId = token.getUser().id;
      queryMemberInfoByUserId(userId).then( res=> {
        this.userInfo = res.data.info;
        this.usernameValue = this.userInfo.username;//存储用户名,修改时进行对比
        //认证状态判断
        if(this.userInfo.companyStatus === '0') {
          this.companyStatusValue = '未认证'
        } else if(this.userInfo.companyStatus === '1') {
          this.companyStatusValue = '认证审核中'
        } else {
          this.companyStatusValue = '认证成功'
        }
        if(this.userInfo.personStatus === '0') {
          this.personStatusValue = '未认证'
        } else if(this.userInfo.personStatus === '1') {
          this.personStatusValue = '认证审核中'
        } else {
          this.personStatusValue = '认证成功'
        }
        //身份证号格式处理
        this.idCardValue = this.userInfo.memberIDCard.replace(/(.{6}).*(.{4})/, "$1********$2");
      })
    },
    //修改用户名
    modifyUsername() {
      if(this.modifyBtnDisabled == false) {
        return;
      }
      let id = this.userInfo.id;
      let newUsername = this.userInfo.username;
      editMemberUsername(id,newUsername).then(res => {
        this.$message.success('修改成功！');
      })
    },
    //显示或隐藏身份证号
    displayIdNumber() {
      if(this.flag == 0) {
        this.imgUrl = require('../../../../assets/console/eyes_open.png');
        this.idCardValue = this.userInfo.memberIDCard;
        this.flag = 1;
      } else {
        this.imgUrl = require('../../../../assets/console/eyes_close.png');
        this.idCardValue = this.userInfo.memberIDCard.replace(/(.{6}).*(.{4})/, "$1********$2");
        this.flag = 0;
      }
    },
    //重新认证
    recertification() {
      this.$router.push({path: '/accountCenter',query:{ index:1}});
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.content {
  .con_header {
    padding: 20px 0 70px;
    margin-top: 20px;
    border: 1px solid #E5E5E5;
    .header_con {
      overflow: hidden;
      margin-top: 20px;
      .header_item {
        float: left;
        position: relative;
        width: 50%;
        height: 32px;
        margin-top: 30px;
        line-height: 32px;
        .item_title {
          position: absolute;
          left: 8%;
          color: #4F4F4F;
        }
        .item_con {
          position: absolute;
          left: 32%;
        }
        .item_btn {
          position: absolute;
          left: 77%;
        }
        .el-input {
          width: 40%;
        }
        .registration_time {
          color: #4F4F4F;
        }
        .modify_btn {
          display: inline-block;
          width: 100px;
          height: 25px;
          background-color: #5984EC;
          font-size: 14px;
          color: #fff;
          text-align: center;
          line-height: 25px;
        }
        .modify_btn:hover {
          cursor: not-allowed;
        }
        .modify_button {
          background-color: #ECECEC;
          color: #BBB;
        }
        .modify_button:hover {
          cursor: not-allowed;
        }
        .unauthenticated_btn {
          display: inline-block;
          width: 157px;
          height: 32px;
          background-color: #ECECEC;
          font-size: 12px;
          color: #BFBFBF;
          text-align: center;
          line-height: 32px;
        }
        .review_btn {
          display: inline-block;
          width: 157px;
          height: 32px;
          background-color: #FFF2E9;
          font-size: 12px;
          color: #FD6C63;
          text-align: center;
          line-height: 32px; 
        }
        .success_btn {
          display: inline-block;
          width: 157px;
          height: 32px;
          background-color: #EAFFEA;
          font-size: 12px;
          color: #6AD73E;
          text-align: center;
          line-height: 32px;  
        }
      }
    }
  }
  // 公共样式开始
  .header_title {
    margin-left: 20px;
    color: #5783EE;
    span {
      margin-left: 20px;
      font-weight: 600;
    }
  }
  // 公共样式结束
  .half_bottom {
    .info_box {
      position: relative;
      padding: 20px 0 70px;
      margin-top: 20px;
      border: 1px solid #E5E5E5;
      .items {
        margin-top: 50px;
        .item {
          position: relative;
          height: 32px;
          margin-top: 25px;
          color: #4F4F4F;
          .item_name {
            position: absolute;
            left: 8%;
          }
          .item_con {
            position: absolute;
            left: 32%;
          }
          .item_btn {
            position: absolute;
            left: 70%;
            width: 34px;
            height: 25px;
          }
          .item_btn:hover {
            cursor: pointer;
          }
        }
      }
      .button {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 132px;
        height: 32px;
        background-color: #5984EC;
        font-size: 14px;
        color: #fff;
        text-align: center;
        line-height: 32px;
      }
      .button:hover {
        cursor: pointer;
        background-color: #6089F3;
      }
    }
  }
}
</style>